/* eslint-disable no-unused-vars */
import React from 'react';
import { Helmet } from 'react-helmet';
import { Button, Icons } from '@components';
import { Outlet, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  mdiBankOutline,
  mdiCalculatorVariantOutline,
  mdiCashFast,
  mdiCashPlus,
  // mdiChartAreaspline,
  mdiChartLine,
  mdiFileTableOutline,
  mdiNoteOutline,
  mdiPercentBoxOutline,
  mdiScriptTextOutline,
  // mdiSwapHorizontal,
} from '@mdi/js';
import {
  CONTRACHEQUE,
  CONVERSAO_BENEFICIOS,
  INFORME_RENDIMENTOS,
  MEMORIA_CALCULO,
  PARCELA_ADICIONAL,
  PERCENTUAL_RENDA_MENSAL_ABSOLUTE_PATH,
  RESERVA_MATEMATICA,
  SAQUE_VISTA,
  TRANSFORMACAO_BENEFICIO,
  // FORM_TRANSFORMACAO_PLA,
  VALOR_BENEFICIO,
  // SIMULACAO_TRANSFORMACAO_PLA,
} from '../../common/utils/paths';

export const BeneficiosPage = () => {
  const navigate = useNavigate();
  const permissionamento = useSelector(
    (state) => state.configs.telasDisponiveis.data
  );
  const custom = useSelector((state) => state.configs.tema);

  return (
    <>
      <Helmet>
        <title>Forluz - Benefícios</title>
      </Helmet>
      <h1 className="fw-bold page-title mb-2 mb-md-3">Benefícios</h1>
      <hr />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32 mt-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <Outlet />

      <div className="row">
        {permissionamento.contracheque && (
          <div className="col-12 col-lg-6 col-xl-4 mb-4">
            <button
              type="button"
              className="card cursor-pointer card-button h-100"
              onClick={() => {
                navigate(CONTRACHEQUE);
              }}
            >
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <Icons
                      path={mdiScriptTextOutline}
                      color={custom.codCorLaranja}
                      alt="File Icon"
                      size={2}
                    />
                  </div>
                  <div className="col">
                    <h1 className="ts-20 fw-bold text-muted">Contracheque</h1>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <p className="text-muted ts-14">
                  Busque e consulte o seu demonstrativo de pagamento mensal
                </p>
              </div>
            </button>
          </div>
        )}
        {permissionamento.simular_conversao_beneficio && (
          <div className="col-12 col-lg-6 col-xl-4 mb-4">
            <button
              type="button"
              className="card cursor-pointer card-button h-100"
              onClick={() => navigate(CONVERSAO_BENEFICIOS)}
            >
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <Icons
                      path={mdiChartLine}
                      color={custom.codCorLaranja}
                      alt="File Icon"
                      size={2}
                    />
                  </div>
                  <div className="col">
                    <h1 className="ts-20 fw-bold text-muted">
                      Conversão de benefícios
                    </h1>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <p className="text-muted ts-14">
                  Realize a simulação de conversão do seu benefício
                </p>
              </div>
            </button>
          </div>
        )}

        {permissionamento.informe_rendimento && (
          <div className="col-12 col-lg-6 col-xl-4 mb-4">
            <button
              type="button"
              className="card cursor-pointer card-button h-100"
              onClick={() => navigate(INFORME_RENDIMENTOS)}
            >
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <Icons
                      path={mdiScriptTextOutline}
                      color={custom.codCorLaranja}
                      alt="File Icon"
                      size={2}
                    />
                  </div>
                  <div className="col">
                    <h1 className="ts-20 fw-bold text-muted">
                      Informe de rendimentos
                    </h1>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <p className="text-muted ts-14">
                  Consulte e faça o download do seu informe de rendimentos
                </p>
              </div>
            </button>
          </div>
        )}
        {permissionamento.memoria_calculo && (
          <div className="col-12 col-lg-6 col-xl-4 mb-4">
            <button
              type="button"
              className="card cursor-pointer card-button h-100"
              onClick={() => navigate(MEMORIA_CALCULO)}
            >
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <Icons
                      path={mdiFileTableOutline}
                      color={custom.codCorLaranja}
                      alt="File Icon"
                      size={2}
                    />
                  </div>
                  <div className="col">
                    <h1 className="ts-20 fw-bold text-muted">
                      Memória cálculo de benefício
                    </h1>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <p className="text-muted ts-14">
                  Confira e acompanhe o histórico do cálculo de seu benefício
                </p>
              </div>
            </button>
          </div>
        )}

        {permissionamento.parcela_adicional && (
          <div className="col-12 col-lg-6 col-xl-4 mb-4">
            <button
              type="button"
              className="card cursor-pointer card-button h-100"
              onClick={() => navigate(PARCELA_ADICIONAL)}
            >
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <Icons
                      path={mdiCashPlus}
                      color={custom.codCorLaranja}
                      alt="File Icon"
                      size={2}
                    />
                  </div>
                  <div className="col">
                    <h1 className="ts-20 fw-bold text-muted">
                      Parcela adicional
                    </h1>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <p className="text-muted ts-14">
                  Caso queira, solicite o recebimento da parcela adicional de
                  aposentadoria, quando a janela estiver aberta
                </p>
              </div>
            </button>
          </div>
        )}

        {permissionamento.alterar_recebimento && (
          <div className="col-12 col-lg-6 col-xl-4 mb-4">
            <button
              type="button"
              className="card cursor-pointer card-button h-100"
              onClick={() => navigate(PERCENTUAL_RENDA_MENSAL_ABSOLUTE_PATH)}
            >
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <Icons
                      path={mdiPercentBoxOutline}
                      color={custom.codCorLaranja}
                      alt="File Icon"
                      size={2}
                    />
                  </div>
                  <div className="col">
                    <h1 className="ts-20 fw-bold text-muted">
                      Percentual Recebimento Renda
                    </h1>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <p className="text-muted ts-14">
                  Informe o percentual de recebimento de renda mensal pretendido
                </p>
              </div>
            </button>
          </div>
        )}

        {permissionamento.reserva_matematica && (
          <div className="col-12 col-lg-6 col-xl-4 mb-4">
            <button
              type="button"
              className="card cursor-pointer card-button h-100"
              onClick={() => navigate(RESERVA_MATEMATICA)}
            >
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <Icons
                      path={mdiCalculatorVariantOutline}
                      color={custom.codCorLaranja}
                      alt="File Icon"
                      size={2}
                    />
                  </div>
                  <div className="col">
                    <h1 className="ts-20 fw-bold text-muted">
                      Reserva Matemática
                    </h1>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <p className="text-muted ts-14">
                  Solicite as informações referentes à sua Reserva Matemática
                </p>
              </div>
            </button>
          </div>
        )}
        {permissionamento.saque_vista && (
          <div className="col-12 col-lg-6 col-xl-4 mb-4">
            <button
              type="button"
              className="card cursor-pointer card-button h-100"
              onClick={() => navigate(SAQUE_VISTA)}
            >
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <Icons
                      path={mdiCashFast}
                      color={custom.codCorLaranja}
                      alt="File Icon"
                      size={2}
                    />
                  </div>
                  <div className="col">
                    <h1 className="ts-20 fw-bold text-muted">Saque à vista</h1>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <p className="text-muted ts-14">
                  Informe o percentual de retirada/parcela à vista, se for o
                  caso
                </p>
              </div>
            </button>
          </div>
        )}
        {permissionamento.transformacao_reserva && (
          <div className="col-12 col-lg-6 col-xl-4 mb-4">
            <button
              type="button"
              className="card cursor-pointer card-button h-100"
              onClick={() => navigate(TRANSFORMACAO_BENEFICIO)}
            >
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <Icons
                      path={mdiBankOutline}
                      color={custom.codCorLaranja}
                      alt="File Icon"
                      size={2}
                    />
                  </div>
                  <div className="col">
                    <h1 className="ts-20 fw-bold text-muted">
                      Transformação de benefício
                    </h1>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <p className="text-muted ts-14">
                  Realize a simulação de transformação de seu benefício e,
                  estando certo(a) de sua escolha, prossiga com a solicitação.
                </p>
              </div>
            </button>
          </div>
        )}
        {permissionamento.cpa && (
          <div className="col-12 col-lg-6 col-xl-4 mb-4">
            <button
              type="button"
              className="card cursor-pointer card-button h-100"
              onClick={() => navigate(VALOR_BENEFICIO)}
            >
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <Icons
                      path={mdiNoteOutline}
                      color={custom.codCorLaranja}
                      alt="File Icon"
                      size={2}
                    />
                  </div>
                  <div className="col">
                    <h1 className="ts-20 fw-bold text-muted">CPA</h1>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <p className="text-muted ts-14">
                  Confira a simulação de valor do seu benefício
                </p>
              </div>
            </button>
          </div>
        )}

        {/* {permissionamento.transformacao_reserva_planoA && (
          <>
            <div className="col-12 col-md-6 col-lg-4 mt-4">
              <FLink to={SIMULACAO_TRANSFORMACAO_PLA} className="">
                <div className="card h-100">
                  <div className="card-body">
                    <Icons
                      path={mdiChartAreaspline}
                      color={custom.codCorLaranja}
                      alt="File Icon"
                      size={2}
                    />
                  </div>
                  <div className="card-footer">
                    <h1 className="ts-20 fw-bold">
                      Simulação de Transformação de benefício Plano A
                    </h1>
                    <p className="text-muted ts-14">
                      Texto descritivo para a simulação de transformação de
                      benefício.
                    </p>
                  </div>
                </div>
              </FLink>
            </div>

            <div className="col-12 col-md-6 col-lg-4 mt-4">
              <FLink to={FORM_TRANSFORMACAO_PLA} className="">
                <div className="card h-100">
                  <div className="card-body">
                    <Icons
                      path={mdiSwapHorizontal}
                      color={custom.codCorLaranja}
                      alt="File Icon"
                      size={2}
                    />
                  </div>
                  <div className="card-footer">
                    <h1 className="ts-20 fw-bold">
                      Solicitação de Transformação de benefício Plano A
                    </h1>
                    <p className="text-muted ts-14">
                      Texto descritivo para a transformação de benefício.
                    </p>
                  </div>
                </div>
              </FLink>
            </div>
          </>
        )} */}
      </div>
    </>
  );
};
